module.exports = __webpack_public_path__ + "static/media/Carrick-Therapeutics.167eec0a.png";